import { useEffect } from 'react';

export function useGlobalSearchHotkey(onOpen: () => void): void {
  useEffect(() => {
    function handler(e: KeyboardEvent): void {
      const isMod = e.metaKey || e.ctrlKey;
      if (!isMod || e.key.toLowerCase() !== 'k') return;
      const active = document.activeElement;
      // Allow Cmd+K even when typing — search is global.
      if (
        active &&
        active.tagName === 'INPUT' &&
        (active as HTMLInputElement).type === 'password'
      ) {
        return;
      }
      e.preventDefault();
      onOpen();
    }
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [onOpen]);
}
